import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import AllAccessRightsOverview from '../components/AllAccessRightsOverview';

export default () => (
  <Fragment>
    <Route
      path="/all-accessrights/:action?/:actionId?/:subAction?/:subActionId?"
      component={AllAccessRightsOverview}
      exact
      menuName="AccessRights"
    />
  </Fragment>
);
